import type { IRecord } from '@/interfaces'

export enum addressType {
	ShipTo = 'Shipping',
	BillTo = 'Billing',
	Event = 'Event'
}

export enum addressClass {
	Primary = 'Primary',
	Secondary = 'Secondary',
	Other = 'Other'
}

export interface IAddress extends IRecord {
	id: string
	active: boolean
	address1?: string
	address2?: string
	address3?: string
	city?: string
	state?: string
	zip?: string
	country?: string
	type: addressType
	addressClass: addressClass
	isPrimary: boolean
}
